module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_6000.d4a9e28c.png";